import style from './Header.module.css'
import {HeaderProfile} from '../HeaderProfile/HeaderProdile'
import {ReactComponent as Notification} from '../../Assets/icons/notifications-icon.svg'
import NotificationModal from '../Modal/NotificationModal'
import { useDispatch, useSelector } from 'react-redux'
import { openOrClose, closeAllSelect } from '../../Redux/Slices/Select/Select'
import { LocationSelect } from '../Select/LocationSelect'
import {setLocation} from '../../Redux/Slices/User'

export function Header(){
    // const user = useSelector(state => state.user.user)
    const regions = useSelector(state => state.user.regions)
    const location = useSelector(state => state.user.location)
    const notificationModalState = useSelector(state => state.select.NotificationModal)
    const dispatch = useDispatch()
    const priceNotifications = useSelector(state => state.user.updatePriceNotifications)
    
    function handleClick() {
        dispatch(openOrClose('NotificationModal'))
        // if(priceNotifications.filter(item => item.state).length > 0) {
        //     dispatch(markAsReadThunk({types : ["PRICE_UPDATE"]}))
        // }
    }
    
    return <div className={style.header}>
        <div className={style.geolocation__container}>
            <LocationSelect options={regions} value={location} setValue={(data) => {
                dispatch(setLocation(data))
            }} />
        </div>
        <div onClick={() => notificationModalState && dispatch(closeAllSelect()) } className={`${style.notification__container} select`}>
            {priceNotifications.filter(item => item.state).length > 0 && <div className={style.notification__count}>{priceNotifications.filter(item => item.state).length}</div>}
            <button onClick={handleClick}><Notification /></button>
            <NotificationModal notifications={priceNotifications} />
        </div>
        <HeaderProfile />
    </div>
}